


$(document).ready(function(){
        
        $(function(){$(window).scroll(function(){
                        $(".item_box").each(function(){var n=$(this).offset().top,e=$(window).scrollTop(),o=$(window).height();e>n-o+0&&$(this).addClass("active")
                        })
                })
        }),
        
        $(function(){$(window).scroll(function(){
                        $(".animation").each(function(){var n=$(this).offset().top,e=$(window).scrollTop(),o=$(window).height();e>n-o+200&&$(this).addClass("active")
                        })
                })
        }),
        
        $(function(){$(window).scroll(function(){
                        $(".f_ani").each(function(){var n=$(this).offset().top,e=$(window).scrollTop(),o=$(window).height();e>n-o+0&&$(this).addClass("active")
                        })
                })
        }),
        
        $(function() {
                $(".sub_grand_menu_top").click(function(){
                        $(".sub_grand_menu_top .button-navi-icon").addClass("close");
                        $(".button-close").css('z-index', '9999');
                        $("html, body").css('overflow', 'hidden');
                        $("#menu_index").fadeIn();
                        $("#menu_back").fadeIn();
                        $("#menu_index").addClass("active");
                        $('#sp_header').removeClass("active");
                });
        });
        
        
        $(function() {
                $(".button-close").click(function(){
                        $(".sub_grand_menu_top .button-navi-icon").removeClass("close");
                        $(".button-close").css('z-index', '-9999');
                        $("html, body").css('overflow', 'visible');
                        $("#menu_index").fadeOut(800);
                        $("#menu_back").fadeOut(800);
                        $("#menu_index").removeClass("active");
                        $('#sp_header').addClass("active");
                });
        });
        
        $(function() {
                $("#menu_back").click(function(){
                        $(".sub_grand_menu_top .button-navi-icon").removeClass("close");
                        $(".button-close").css('z-index', '-9999');
                        $("html, body").css('overflow', 'visible');
                        $("#menu_index").fadeOut(800);
                        $("#menu_back").fadeOut(800);
                        $("#menu_index").removeClass("active");
                        $('#sp_header').addClass("active");
                        $("#sort_menu").fadeOut(800);
                  $("#sort_menu").removeClass("active");
                });
        });


  
$(".h_search_btn").click(function () {
  $("#header_search").fadeToggle("300");
});

  
  
        
        
        $(function() {
                $(".filter_btn").click(function(){
                        $("html, body").css('overflow', 'hidden');
                        $("#sort_menu").fadeIn();
                       $("#sort_menu").addClass("active");
                        $("#menu_back").fadeIn();
                });
        });

          $(function() {
                $(".sort_close span").click(function(){
                        $("html, body").css('overflow', 'visible');
                        $("#sort_menu").fadeOut(800);
                        $("#menu_back").fadeOut(800);
                        $("#sort_menu").removeClass("active");
                });
        });

  
        
        
        $(window).load(function () {
                $('.first_animation').delay(2500).fadeOut(1000);
                $('body').delay(2500).queue(function(){
                        $(this).addClass('open');
                });
        });
        
        
        
        
        
        $(window).on('scroll',function(){
                var winPosTop = $(window).scrollTop();
                if(winPosTop >= 700){
                    $('#menu_scroll, .footer_backto').addClass("active");
                } else if(winPosTop < 700){
                    $('#menu_scroll, .footer_backto').removeClass("active");
                }
        });
        
        
        $('a.ancher, .page_top a').click(function(){
                var target = $(this.hash);
                //$(this).text(target.length+"/");
                if (target) {
                    var targetOffset = target.offset().top;
                    $('html,body').animate({scrollTop: targetOffset},1400,"easeInOutQuint");
                return false;}
        });
        
        
        
        
        
        
    });
















